import { CmsSlot } from '~/commons/interfaces/models/content/cms/CmsPage'

/**
 * @alpha
 */
export function getCmsSlotDataElements(content: CmsSlot): any[] {
  return content.data?.elements || []
}
